import { gql } from "@apollo/client";

// import { FRAGMENT as VIDEO_FRAGMENT } from "../../components/LibraryPostVideoCard";
import { FRAGMENT as GUIDE_FRAGMENT } from "../../components/LibraryGuideCard";

export const GUIDES = gql`
  query GuidesHome {
    libraryGuides {
      nodes {
        ...LibraryGuideCardComponent
      }
    }
  }

  ${GUIDE_FRAGMENT}
`;
